var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_33",
    "data-name": "Elipse 33",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(7074 1932)",
    fill: "#5d3b3b",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_546",
    "data-name": "Grupo 546",
    transform: "translate(-378 -1066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_544",
    "data-name": "Grupo 544",
    transform: "translate(-6694 -860)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_34",
    "data-name": "Elipse 34",
    transform: "translate(7072 1926)",
    fill: "#fff",
    stroke: "#334161",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_9",
    "data-name": "Enmascarar grupo 9",
    transform: "translate(0 -2)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_User_750578",
    transform: "translate(7075.35 1935.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3303",
    "data-name": "Trazado 3303",
    d: "M38.871,39.548a.147.147,0,0,1-.108-.147V37.294a16.131,16.131,0,0,0,2.7-5.347A10.921,10.921,0,0,0,43.8,27.223c.566-1.9,1.082-4.662-.408-6.638l-.068-.091c.719-3.461,1.614-11.64-4.6-15.786a3.829,3.829,0,0,0,1.093-2.792.368.368,0,0,0-.13-.261.391.391,0,0,0-.278-.085c-.079,0-7.85.884-11.594.108-3.84-.8-8.066,2.118-8.932,5.1a5.664,5.664,0,0,0-3.682,2.079c-1.7,2.09-2.215,5.426-1.546,9.9.045.566.113,1.133.215,1.7l-.068.085c-1.49,1.971-.946,4.73-.408,6.638a10.856,10.856,0,0,0,2.334,4.718,16.2,16.2,0,0,0,2.7,5.387V39.35a.142.142,0,0,1-.108.147C13.015,40.771.65,44.691.65,54.479A1.931,1.931,0,0,0,2.581,56.41H54.623a1.931,1.931,0,0,0,1.931-1.931C56.555,44.691,44.19,40.771,38.871,39.548ZM28.6,47.053a10.2,10.2,0,0,1-8.36-4.157,3.965,3.965,0,0,0,1.818-2.164,12.942,12.942,0,0,0,2.792,1.393,11.243,11.243,0,0,0,7.5,0,13.219,13.219,0,0,0,2.781-1.4,3.965,3.965,0,0,0,1.83,2.192,10.2,10.2,0,0,1-8.36,4.14ZM16.736,26.277c-.685-2.419-.4-3.3-.164-3.6a.787.787,0,0,1,.68-.295h.164a.368.368,0,0,0,.385-.34c0-.051.43-5.262,3.517-7.137,1.541-.94,3.523-.9,5.885.108,4.837,2.084,8.44,1.937,10.632,1.45a4.911,4.911,0,0,1,1.609,5.37V21.9a.37.37,0,0,0,.379.493.884.884,0,0,1,.827.289c.232.306.521,1.184-.164,3.6-.878,3.1-1.592,3.4-1.79,3.4a.362.362,0,0,0-.334.312,11.807,11.807,0,0,1-7.171,8.859,7.726,7.726,0,0,1-5.171,0,11.547,11.547,0,0,1-7.159-8.864.363.363,0,0,0-.334-.312C18.328,29.664,17.614,29.375,16.736,26.277Z",
    fill: "#314164"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.154a7c21fb156fc95168821e8d68810c.svg";
export { ForwardRef as ReactComponent };